import { AnyPropsType } from '~/AnyPropsType';
import cx from 'classnames';
import React from 'react';

import attachment from './icons/12px/attachment.svg';
import calendar from './icons/12px/calendar.svg';
import checkOutlined from './icons/12px/check-outlined.svg';
import checkSquare from './icons/12px/check-square.svg';
import check from './icons/12px/check.svg';
import chevronLeftBig from './icons/12px/chevron-left.svg';
import clock from './icons/12px/clock.svg';
import close from './icons/12px/close.svg';
import eye from './icons/12px/eye.svg';
import unseen from './icons/12px/unseen.svg';
import add from './icons/16px/add.svg';
import alert from './icons/16px/alert.svg';
import arrowBack from './icons/16px/arrow-back.svg';
import arrowForward from './icons/16px/arrow-forward.svg';
import bellUnactive from './icons/16px/bell-unactive.svg';
import bell from './icons/16px/bell.svg';
import checkboxSquare from './icons/16px/checkbox-square.svg';
import closeBig from './icons/16px/close.svg';
import copyright from './icons/16px/copyright.svg';
import date from './icons/16px/date.svg';
import deleteIcon from './icons/16px/delete.svg';
import docx from './icons/16px/docx.svg';
import duplicate from './icons/16px/duplicate.svg';
import edit from './icons/16px/edit.svg';
import fileText from './icons/16px/file-text.svg';
import flag from './icons/16px/flag.svg';
import lock from './icons/16px/lock.svg';
import maximize from './icons/16px/maximize.svg';
import minimize from './icons/16px/minimize.svg';
import minus from './icons/16px/minus.svg';
import pdf from './icons/16px/pdf.svg';
import plus from './icons/16px/plus.svg';
import pwc from './icons/16px/pwc.svg';
import remove from './icons/16px/remove.svg';
import search from './icons/16px/search.svg';
import support from './icons/16px/support.svg';
import tick from './icons/16px/tick.svg';
import time from './icons/16px/time.svg';
import trash from './icons/16px/trash.svg';
import undefinedFileType from './icons/16px/undefined.svg';
import unseenBig from './icons/16px/unseen.svg';
import xbrl from './icons/16px/xbrl.svg';
import xlsm from './icons/16px/xlsm.svg';
import xlsx from './icons/16px/xlsx.svg';
import xml from './icons/16px/xml.svg';
import chevronDown from './icons/8px/chevron-down.svg';
import chevronLeft from './icons/8px/chevron-left.svg';
import chevronRight from './icons/8px/chevron-right.svg';
import chevronUp from './icons/8px/chevron-up.svg';
import s from './styles.module.scss';

// 8px
// 12px
// 16px
export const Icon = ({ icon, className, disabled, ...props }: AnyPropsType) => (
  <svg {...props} className={cx(s.icon, className, disabled && s.iconDisabled)} viewBox={icon.viewBox}>
    <use xlinkHref={`#${icon.id}`} />
  </svg>
);

Icon.icons = {
  chevronDown,
  chevronUp,
  chevronLeft,
  chevronRight,
  attachment,
  calendar,
  check,
  checkOutlined,
  checkSquare,
  close,
  clock,
  unseen,
  duplicate,
  add,
  bell,
  bellUnactive,
  closeBig,
  deleteIcon,
  edit,
  eye,
  lock,
  maximize,
  minimize,
  minus,
  plus,
  remove,
  search,
  trash,
  unseenBig,
  chevronLeftBig,
  arrowBack,
  arrowForward,
  flag,
  date,
  pwc,
  time,
  fileText,
  docx,
  pdf,
  xlsx,
  undefinedFileType,
  xml,
  xbrl,
  xlsm,
  alert,
  copyright,
  tick,
  checkboxSquare,
  support,
};

Icon.defaultProps = {
  className: null,
  disabled: false,
};
